function getElement (value, ids) {
  for (var i = 0; i < ids.length; i++) {
    var el = $(ids[i]);
    if (el.val() === value) {
      return el;
    }
  }
  return el;
}

var ChangePasswordModel = Backbone.Epoxy.Model.extend({
  /**
   * Initialize this model.
   *
   * You must keep the `Backbone.Validation.bind` call if you want this model to have validation.
   */
  initialize: function() {
    Backbone.Validation.bind(this, {liveValidation: true});
  },

  computeds: {},

   /**
    * Hash of validations.  Example listed is a manual function.
    * See https://github.com/sibrus/backbone.validation/tree/epoxy for built-in validators and other details.
    */
   validation: {
     oldPassword: [
      {
        fn: function (value) {
          var el = getElement(value, ["#oldPassword"]);

          if (!value) {
            el.attr("aria-invalid", "true");
            return 'Please enter your existing password.';
          }
          el.attr("aria-invalid", "false");
        }
      },
    ],
    newPassword: [
      {
        fn: function (value) {
          var el = getElement(value, ["#newPassword"]);
          let vRes = global.bookedby.helpers.passwordValidate(value);
          if (vRes.isValid) {
            el.attr("aria-invalid", "false");
            return null;
          }
            el.attr("aria-invalid", "true");
          return vRes.errorMsg;
          }
        }
    ],
    newPasswordConfirm: [
      {
        fn: function (value) {
          var el = getElement(value, ["#newPasswordConfirm"]);
          const vRes = global.bookedby.helpers.confirmPasswordValidate(value, this.get('newPassword'));
          if (vRes.isValid) {
            el.attr("aria-invalid", "false");
            return null;
          }
            el.attr("aria-invalid", "true");
          return vRes.errorMsg;
        }
      },
    ]
  },

  /**
   * Property hash with default values.
   */
  defaults: {
    oldPassword: null,
    newPassword: null,
    newPasswordConfirm: null,
    successPayload: {
      successCallback: null
    }
  },
});

module.exports = ChangePasswordModel;
